/* so-cart-identity: remember the so-mail link id (30 days), link the cart once, tag it _so_r. */
(function () {
  var root = document.querySelector('[data-so-cart-identity]');
  if (!root) return;
  var COOKIE = 'so_r', DAY = 864e5;
  function readCookie() {
    // A cookie read can throw (sandboxed frame, some privacy modes); a logged-in
    // customer must still be linked without it.
    try {
      var m = document.cookie.match(/(?:^|; )so_r=([^;]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  try {
    var sm = new URLSearchParams(location.search).get('sm');
    if (sm && /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(sm)) {
      document.cookie = COOKIE + '=' + encodeURIComponent(sm) + ';path=/;max-age=' + (30 * DAY / 1000) + ';samesite=lax;secure';
    }
    // Take sm out of the address bar once remembered, so a product URL copied and
    // shared never passes this person's identity on. Other params and the hash stay
    // exactly as they were.
    if (sm !== null) {
      var rest = location.search.slice(1).split('&').filter(function (kv) { return kv && kv.split('=')[0] !== 'sm'; });
      history.replaceState(history.state, '', location.pathname + (rest.length ? '?' + rest.join('&') : '') + location.hash);
    }
  } catch (e) {}

  // The script's own requests use the page's original fetch, never the wrapper below:
  // its /cart/update.js would otherwise count as a cart mutation and schedule another
  // linkCart - forever, when that update keeps failing and so leaves no mark.
  var origFetch = window.fetch;
  function ownFetch(url, init) { return origFetch.call(window, url, init); } // unbound fetch throws "Illegal invocation"
  // Attempts per cart + identity in this page view. A failure leaves no mark so a later
  // load retries; within one view, a run of cart changes retries at most MAX_TRIES times.
  var MAX_TRIES = 3, tries = {};
  // A cart change that lands while a link is in flight is not dropped: it sets
  // rerun, and the in-flight run calls linkCart once more when it finishes.
  var busy = false, rerun = false;
  function linkCart() {
    if (busy) { rerun = true; return; }
    var sm = readCookie(), cid = root.dataset.customerId, sig = root.dataset.customerSig;
    if (!sm && !cid) return;
    busy = true;
    ownFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.token || !cart.item_count) return;
      var token = String(cart.token).split('?')[0];
      var mark = 'so_cart_linked:' + token + ':' + (cid || sm);
      var jobs = [];
      try { if (localStorage.getItem(mark)) return; } catch (e) {}
      if ((tries[mark] = (tries[mark] || 0) + 1) > MAX_TRIES) return;
      // keepalive: a click through to checkout right after add-to-cart must not cancel these.
      jobs.push(ownFetch(root.dataset.endpoint, {
        method: 'POST', credentials: 'omit', keepalive: true, headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ cartToken: token, sm: sm || undefined, customerId: cid || undefined, customerSig: sig || undefined })
      }));
      if (sm && (!cart.attributes || cart.attributes._so_r !== sm)) {
        jobs.push(ownFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'content-type': 'application/json' }, body: JSON.stringify({ attributes: { _so_r: sm } }) }));
      }
      // Linked only when every call succeeded (/cart-link answers 204): a 429 or
      // 5xx leaves no mark, so the next page load tries again.
      return Promise.all(jobs).then(function (rs) {
        if (rs.every(function (r) { return r.ok; })) { try { localStorage.setItem(mark, '1'); } catch (e) {} }
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (rerun) { rerun = false; linkCart(); }
    });
  }

  // Run on load, and after any cart mutation made anywhere else on the page.
  window.fetch = function (input) {
    // A string, a Request (.url) or a URL object (.href).
    var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || String(input || '');
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
      p.then(function () { setTimeout(linkCart, 300); }).catch(function () {});
    }
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', linkCart); else linkCart();
})();
